export default "__VITE_ASSET__Wq98Q4ww__"